/** @format */
import angular from 'angular';

export const commonSharedModule = 'sis-components.shared';

(function () {
    angular.module(commonSharedModule, []);
})();
